<script setup>
import { computed, inject } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';
import { PrimaryButton } from '@es-bill/es-bill-common-components';
import { useCommunityProviderStore } from '@/stores/communityProviderStore';
import { useCommunityCompaniesStore } from '@/stores/communityCompaniesStore';

const $log = inject('log');
const { t } = useI18n();
const router = useRouter();
const providerStore = useCommunityProviderStore();
const companiesStore = useCommunityCompaniesStore();

providerStore.fetchProviders().catch(() => {});
if (!companiesStore.allCommunityCompanies.length)
  companiesStore.fetchCommunityCompanies().catch(() => {});

const sortBy = [{ key: 'nameFriendly', order: 'asc' }];

const tableHeader = computed(() => [
  { title: t('communityProviders.nameFriendly'), value: 'nameFriendly' },
  { title: t('name'), value: 'name' },
  { title: t('communityProviders.legal'), value: 'legal' },
  { title: t('communityProviders.assignedCompanies'), value: 'assignedCount' },
  { title: t('serviceFees.title'), value: 'feeCount' },
]);

function providerCompanyCount(providerId) {
  return companiesStore.allCommunityCompanies.filter(c => {
    const ref = c.communityProvider;
    const refId = ref && typeof ref === 'object' ? ref._id : ref;
    return refId === providerId;
  }).length;
}

const rows = computed(() => providerStore.allProviders.map(p => ({
  ...p,
  assignedCount: providerCompanyCount(p._id),
  feeCount: (p.serviceFees || []).length,
})));

function openProvider(event, { item }) {
  router.push({ name: 'communityProviderForm', params: { id: item._id } });
}

function onCreate() {
  router.push({ name: 'communityProviderForm' });
}
</script>

<template>
  <v-container class="pa-0">
    <div class="d-flex justify-space-between align-center mb-4">
      <p class="textHeadline flex-grow-1">{{ t('communityProviders.title') }}</p>
      <PrimaryButton :text="t('communityProviders.create')" @click="onCreate" />
    </div>

    <v-data-table
      class="elevation-2 mainViewContent"
      :headers="tableHeader"
      :items="rows"
      :sort-by="sortBy"
      :loading="providerStore.providersLoading"
      :items-per-page="25"
      density="comfortable"
      @click:row="openProvider"
    />
  </v-container>
</template>
